"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var baseStyles = process.env.NODE_ENV === "production" ? {
  name: "13llaqn-baseStyles",
  styles: "font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;color:inherit;;label:baseStyles;"
} : {
  name: "13llaqn-baseStyles",
  styles: "font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;color:inherit;;label:baseStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9iYXNlU3R5bGVzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVtQiIsImZpbGUiOiIuLi8uLi9zcmMvdXRpbHMvYmFzZVN0eWxlcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5cbmNvbnN0IGJhc2VTdHlsZXMgPSBjc3Moe1xuICBmb250RmFtaWx5OiAnaW5oZXJpdCcsXG4gIGZvbnRTaXplOiAnaW5oZXJpdCcsXG4gIGZvbnRXZWlnaHQ6ICdpbmhlcml0JyxcbiAgbGluZUhlaWdodDogJ2luaGVyaXQnLFxuICBjb2xvcjogJ2luaGVyaXQnLFxufSlcblxuZXhwb3J0IGRlZmF1bHQgYmFzZVN0eWxlc1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _default = baseStyles;
exports["default"] = _default;